import {ValueObject} from '@s-ui/domain'

export class GetModelImageRequestValueObject extends ValueObject {
  #makeId
  #modelId
  #angle

  constructor({makeId, modelId, angle = 45}) {
    super()
    this.#makeId = makeId
    this.#modelId = modelId
    this.#angle = angle
  }

  static create({makeId, modelId, angle}) {
    return new GetModelImageRequestValueObject({makeId, modelId, angle})
  }

  toJSON() {
    return {
      makeId: this.#makeId,
      modelId: this.#modelId,
      angle: this.#angle
    }
  }
}
